import {FC, useEffect, useState} from 'react'
import {Card, Spinner} from 'react-bootstrap'
import MatrixRain from './MatrixRain'

const STEPS = [
  'Retrieving preferential tariffs and trade flows…',
  'Recomputing applied tariffs after removing excluded agreements…',
  'Calculating trade creation and diversion effects…',
  'Aggregating results by commodity and economy…',
]

const PreferenceLossLoading: FC<{reporterName: string; dataReady: boolean}> = ({
  reporterName,
  dataReady,
}) => {
  const [step, setStep] = useState(0)
  useEffect(() => {
    if (dataReady) return
    const t = setInterval(() => setStep((s) => (s + 1) % STEPS.length), 1500)
    return () => clearInterval(t)
  }, [dataReady])

  return (
    <Card className='text-white' style={{background: '#1e1e2d'}}>
      <Card.Body className='text-center py-10'>
        <Spinner animation='border' variant='light' className='mb-4' />
        <h4 className='text-white mb-4'>
          {dataReady
            ? 'Preparing the overview of results…'
            : `Simulating preference loss for ${reporterName}`}
        </h4>
        {!dataReady && <div className='mb-5'>{STEPS[step]}</div>}
        <MatrixRain />
      </Card.Body>
    </Card>
  )
}

export default PreferenceLossLoading
